import { HttpRequestDecorator } from 'app/core/triggerbee/http.request.decorator';
import { TriggerbeeApi } from 'app/core/triggerbee/triggerbee-api.enum';

/** The one prefix every Community route sits under. There is no `api/` segment at the Gateway. */
export const COMMUNITY_ROUTE_PREFIX = 'community';

/**
 * Builds an absolute Community URL from a path that excludes the `community/` prefix.
 *
 * A free function rather than a base class the twelve services extend: a base class would have to hold
 * `HttpRequestDecorator` as a protected member in every subclass, against the house rule that members
 * default to private. Note the path argument differs from the house `resource()` habit elsewhere, which
 * takes the whole sub-resource — here the prefix is added, so `admin/work-items` is correct and
 * `community/admin/work-items` would double it.
 */
export function communityResource(http: HttpRequestDecorator, path: string): string {
  return `${http.getBaseUrl(TriggerbeeApi.Gateway)}/${COMMUNITY_ROUTE_PREFIX}/${path}`;
}
